import { Snackbar } from "@mui/material";
import useAPIError from "../../common/hooks/useAPIError";
import GeneralErrorMessage from "./general-error";

export default function APIErrorNotification() {
  const { error } = useAPIError();
  return (
    <Snackbar
      open={error !== undefined}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={6000}
    >
      <GeneralErrorMessage />
    </Snackbar>
  );
}
